export default "__VITE_PUBLIC_ASSET__b4a7441a__"